// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

export enum VideoLogEvent {
  InputAttached,
  SendingFailed,
  SendingSuccess,
}

export default VideoLogEvent;
